import { Expose } from 'class-transformer'

export class BookChapterPurchaseType {
  @Expose() id: number

  @Expose() chapterName: string

  @Expose() chapterTitle: string

  @Expose() runningNo: number

  number: number
}
